import { Middleware } from 'redux';
import handleStorageBrowser from '../helpers/handleStorageBrowser';
import { EP } from '../configs/constant';

const cartMiddleware: Middleware = store => next => action => {
    const result = next(action);

    // Lưu trạng thái giỏ hàng vào localStorage
    handleStorageBrowser.setItemLocalStorage(EP.CART, store.getState().cart.cartInfo);

    return result;
};

export default cartMiddleware;